import {useTranslation} from '@aboutyou/i18n';
import {useTrackOnCloseFilter} from '@aboutyou/tracking';
import {
  FilterFlyout as FilterFlyoutUiComponent,
  GridType,
  ProductImageType,
} from '@aboutyou/ui-components';
import React from 'react';
import {useFilterFlyout} from '../shared/useFilterFlyout';

export interface FilterFlyoutProps {
  gridType: GridType;
  onChangeGridType: (gridType: GridType) => void;
  onChangeProductImageType: (productImageType: ProductImageType) => void;
  productImageType?: ProductImageType;
  FilterContent: React.FC<
    Omit<FilterFlyoutProps, 'FilterContent'> & {
      onClose: VoidFunction;
      onPrimaryButtonClick: VoidFunction;
    }
  >;
}

export const FilterFlyout: React.FC<FilterFlyoutProps> = ({
  FilterContent,
  ...otherProps
}) => {
  const {cancel: closeFlyout, submit, isOpen} = useFilterFlyout();

  const trackOnCloseFilter = useTrackOnCloseFilter();
  const {t} = useTranslation();

  const onClose = () => {
    trackOnCloseFilter('', 'filter_modal');
    closeFlyout();
  };

  const onPrimaryButtonClick = () => {
    submit();
  };

  const title = t('Filter & Sort');

  return (
    <FilterFlyoutUiComponent title={title} open={isOpen} onClose={onClose}>
      <FilterContent
        onClose={onClose}
        onPrimaryButtonClick={onPrimaryButtonClick}
        {...otherProps}
      />
    </FilterFlyoutUiComponent>
  );
};
